import utils from 'utils'
import modalDistribution from './view/modalDistribution.html'

class distributionCtrl {
    constructor($scope, $uibModal, httpRequest, logger, $timeout, distributionService, querySort, initSortService) {
        $scope.totalPages = 0
        $scope.standaloneFlag = 0
        const { saleCreditCode } = JSON.parse(localStorage.user_info).sale
        const { saleId } = JSON.parse(localStorage.user_info).sale
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                fpzl: '',
            },
        }

        $scope.reset = function () {
            $scope.queryParam.param = {
                fpzl: '',
            }
        }

        // $scope.reset()
        $scope.dataList = ''
        // [网络分配]按钮显隐
        function setStandaloneFlagInDataList(dataList, setStandaloneFlagIfHasKey) {
            return dataList.map((val) => {
                if (IS_NO_KEY) {
                    val.standaloneFlag = ($scope.diskCode == 0) || (!+val.zdh)
                } else {
                    val.standaloneFlag = setStandaloneFlagIfHasKey === 0 || $scope.diskCode == 0
                }
                return val
            })
        }
        httpRequest.get_getDiskBySaleId({ saleId }).then((res) => {
            $scope.diskData = res.data.value
            $scope.diskData.forEach((element) => {
                element.diskName = `${element.diskCode}号分机(${element.diskName})`
            })
            initDistribution()
        })
        async function initDistribution() {
            try {
                const res = await distributionService.getDiskInfo($scope.diskData)
                $scope.diskTaxCode = res.TaxCode
                $scope.diskCode = res.kpfwqh
                $timeout(() => {
                    $scope.diskSelectedModel = $scope.diskData.filter((item) => item.diskCode == $scope.diskCode)[0]
                })
                console.log($scope.diskSelectedModel)
                if (!IS_NO_KEY && saleCreditCode != $scope.diskTaxCode) {
                    logger.logError('金税盘的税号与用户所在企业税号不一致，请重新插入')
                    return
                }

                $scope.resArr = await distributionService.queryInvoiceStock($scope.diskCode)
                $timeout(() => {
                    const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                    $scope.dataList = setStandaloneFlagInDataList(result.resList, 1)
                    $scope.totalPages = result.num
                    $scope.queryParam.pageNum = ++result.prePage
                })
            } catch (e) {
                if (!IS_NO_KEY) {
                    const res2 = await distributionService.get_qryServerDiskOfPlugged()
                    $scope.diskCode = res2.diskCode
                    $timeout(() => {
                        $scope.diskSelectedModel = $scope.diskData.filter((item) => item.diskCode == $scope.diskCode)[0]
                    })
                    $scope.resArr = res2.analysisXml
                    const pageRes = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                    // $timeout(() => {
                    $scope.dataList = setStandaloneFlagInDataList(pageRes.resList, 0)
                    $scope.totalPages = pageRes.num
                    $scope.queryParam.pageNum = ++pageRes.prePage
                } else {
                    logger.logError(e.data.message)
                }
            }
        }

        $scope.netDistribution = function (item) {
            $uibModal.open({
                template: modalDistribution,
                controller: 'modalDistributionCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-distribution mod-modal',
                resolve: {
                    items1() {
                        return {
                            obj: item,
                            diskCode: $scope.diskCode,
                            diskData: $scope.diskData,
                        }
                    },
                },
            }).result.then(() => {
                if ($scope.diskSelectedModel.diskCode == 0) {
                    distributionService.queryInvoiceStock($scope.diskCode).then((res) => {
                        $scope.resArr = res
                        $timeout(() => {
                            const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                            $scope.dataList = setStandaloneFlagInDataList(result.resList, 1)
                            $scope.totalPages = result.num
                            $scope.queryParam.pageNum = ++result.prePage
                        })
                    })
                } else if ($scope.diskSelectedModel.diskType == 2) {
                    distributionService.queryInvoiceStock().then((res) => {
                        $scope.resArr = res
                        $timeout(() => {
                            const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                            $scope.dataList = setStandaloneFlagInDataList(result.resList, 1)
                            $scope.totalPages = result.num
                            $scope.queryParam.pageNum = ++result.prePage
                        })
                    }, (err) => {
                        logger.logError(err)
                    })
                } else if ($scope.diskSelectedModel.diskType == 1 && !IS_NO_KEY) {
                    distributionService.get_qryServerDiskOfPlugged($scope.diskSelectedModel.diskCode).then((res) => {
                        $scope.resArr = res.analysisXml
                        const pageRes = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                        $scope.dataList = setStandaloneFlagInDataList(pageRes.resList, 0)
                        $scope.totalPages = pageRes.num
                        $scope.queryParam.pageNum = ++pageRes.prePage
                    })
                } else if ($scope.diskSelectedModel.diskType == 1 && IS_NO_KEY) {
                    distributionService.queryInvoiceStock($scope.diskSelectedModel.diskCode).then((res) => {
                        $scope.resArr = res
                        $timeout(() => {
                            const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                            $scope.dataList = setStandaloneFlagInDataList(result.resList, 0)
                            $scope.totalPages = result.num
                            $scope.queryParam.pageNum = ++result.prePage
                        })
                    })
                }
            })
        }

        httpRequest.get_dictByTypeArr(['stock_inv_type']).then((res) => {
            $scope.dictData = res.data.value
        })


        $scope.queryList = function queryList() {
            if (!$scope.resArr) return
            const data = utils.searchData($scope.resArr, [{
                type: 'fpzl', value: $scope.queryParam.param.fpzl,
            }])
            const res = utils.paging(data, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
            $timeout(() => {
                $scope.dataList = setStandaloneFlagInDataList(res.resList, this.diskSelectedModel.diskType == 2 ? 1 : 0)
                $scope.totalPages = res.num
                $scope.queryParam.pageNum = ++res.prePage
                $scope.selectedHandle(true)
            })
        }
        $scope.diskChange = function diskChange() {
            $scope.resArr = []
            // $scope.dataList = []
            const _that = this.diskSelectedModel
            if (_that.diskCode == 0) {
                distributionService.getDiskInfo([_that]).then((res) => {
                    $scope.diskTaxCode = res.TaxCode
                    if (!IS_NO_KEY && saleCreditCode != $scope.diskTaxCode) {
                        logger.logError('金税盘的税号与用户所在企业税号不一致，请重新插入')
                        return
                    }
                    // $scope.standaloneFlag = +!IS_NO_KEY;
                    $scope.diskCode = res.kpfwqh
                    $scope.diskSelectedModel = $scope.diskData.filter((item) => item.diskCode == $scope.diskCode)[0]

                    if (!IS_NO_KEY && _that.diskCode != $scope.diskCode) {
                        logger.logError('未检测到0号开票机，请插入后，重新刷新本页面')
                    } else {
                        distributionService.queryInvoiceStock($scope.diskCode).then((res) => {
                            $scope.resArr = res
                            $timeout(() => {
                                const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                                $scope.dataList = setStandaloneFlagInDataList(result.resList, 1)
                                $scope.totalPages = result.num
                                $scope.queryParam.pageNum = ++result.prePage
                            })
                        })
                    }
                }, (error) => {
                    $scope.dataList = []
                    logger.logError(error)
                    $scope.$apply()
                })
            } else if (_that.diskType == 2) {
                distributionService.getDiskInfo([_that]).then((res) => {
                    $scope.diskTaxCode = res.TaxCode
                    if (!IS_NO_KEY && saleCreditCode != $scope.diskTaxCode) {
                        logger.logError('金税盘的税号与用户所在企业税号不一致，请重新插入')
                        return
                    }
                    // $scope.standaloneFlag = 1;
                    $scope.diskCode = res.kpfwqh
                    $scope.diskSelectedModel = $scope.diskData.filter((item) => item.diskCode == $scope.diskCode)[0]
                    if (!IS_NO_KEY && _that.diskCode != $scope.diskCode) {
                        logger.logError(`未检测到${_that.diskCode}号开票机，请插入后，重新刷新本页面`)
                    } else {
                        distributionService.queryInvoiceStock().then((res) => {
                            $scope.resArr = res
                            $timeout(() => {
                                const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                                $scope.dataList = setStandaloneFlagInDataList(result.resList, 1)
                                $scope.totalPages = result.num
                                $scope.queryParam.pageNum = ++result.prePage
                            })
                        }, (error) => {
                            logger.logError(error)
                        })
                    }
                }, (error) => {
                    $scope.dataList = []
                    logger.logError(error)
                    $scope.$apply()
                })
            } else if (_that.diskType == 1 && !IS_NO_KEY) {
                httpRequest.get_qryServerDiskOfPlugged({ diskCode: _that.diskCode }).then((res) => {
                    // $scope.standaloneFlag = 0;
                    $scope.diskCode = res.data.value.diskCode
                    $scope.diskSelectedModel = $scope.diskData.filter((item) => item.diskCode == $scope.diskCode)[0]
                    if (_that.diskCode != $scope.diskCode) {
                        logger.logError(`未检测到${_that.diskCode}号服务器，请检测网络和分盘服务器后刷新本页面`)
                    } else {
                        const reg = {
                            fpdm: /<TypeCode>(.*?)<\/TypeCode>/g,
                            fpzl: /<InvKind>(.*?)<\/InvKind>/g,
                            fphm: /<StartNO>(.*?)<\/StartNO>/g,
                            count: /<Count>(.*?)<\/Count>/g,
                            fpsysl: /<Remain>(.*?)<\/Remain>/g,
                            machineNo: /<Machine>(.*?)<\/Machine>/g,
                            gmrq: /<BuyDate>(.*?)<\/BuyDate>/g,
                            id: /<ID>(.*?)<\/ID>/g,
                        }
                        $scope.resArr = utils.analysisXml(reg, res.data.value.reportXml).value
                        const pageRes = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                        // $timeout(() => {
                        $scope.dataList = setStandaloneFlagInDataList(pageRes.resList, 0)
                        $scope.totalPages = pageRes.num
                        $scope.queryParam.pageNum = ++pageRes.prePage
                        // })
                    }
                }, (err) => {
                    $scope.dataList = []
                    $scope.$apply()
                })
            } else if (_that.diskType == 1 && IS_NO_KEY) {
                distributionService.getDiskInfo([_that]).then((res) => {
                    $scope.diskTaxCode = res.TaxCode
                    if (!IS_NO_KEY && saleCreditCode != $scope.diskTaxCode) {
                        logger.logError('金税盘的税号与用户所在企业税号不一致，请重新插入')
                        return
                    }
                    // $scope.standaloneFlag = 0;
                    $scope.diskCode = res.kpfwqh
                    $scope.diskSelectedModel = $scope.diskData.filter((item) => item.diskCode == $scope.diskCode)[0]

                    if (!IS_NO_KEY && _that.diskCode != $scope.diskCode) {
                        logger.logError('未检测到0号开票机，请插入后，重新刷新本页面')
                    } else {
                        distributionService.queryInvoiceStock($scope.diskCode).then((res) => {
                            $scope.resArr = res
                            $timeout(() => {
                                const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                                $scope.dataList = setStandaloneFlagInDataList(result.resList, 0)
                                $scope.totalPages = result.num
                                $scope.queryParam.pageNum = ++result.prePage
                            })
                        })
                    }
                }, (error) => {
                    $scope.dataList = []
                    logger.logError(error)
                    $scope.$apply()
                })
            }
        }
        // 表头排序
        $scope.orderMap = initSortService()
        $scope.selectedHandle = function (haveData) {
            const { sortKey } = $scope.orderMap
            let list = []
            let type = 'string'
            if (sortKey == 'gmrq') {
                type = 'date'
            } else if (sortKey == 'count' || sortKey == 'fpsysl' || sortKey == 'fpdm' || sortKey == 'fphm') {
                type = 'num'
            }
            const flag = $scope.orderMap.sortVal == 'desc' ? 1 : -1
            if (haveData) {
                list = JSON.parse(JSON.stringify($scope.dataList))
                if (!list.length) return
                if ($scope.orderMap.sortVal) {
                    list.sort((a, b) => querySort.compareFun(a[sortKey], b[sortKey], type) * flag)
                }
                $scope.dataList = list
                return
            }
            if (!$scope.resArr) return
            const data = utils.searchData($scope.resArr, [{
                type: 'fpzl', value: $scope.queryParam.param.fpzl,
            }])
            const res = utils.paging(data, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
            $timeout(() => {
                list = setStandaloneFlagInDataList(res.resList, this.diskSelectedModel.diskType == 2 ? 1 : 0)
                list = JSON.parse(JSON.stringify(list))
                if (!list.length) return
                if ($scope.orderMap.sortVal) {
                    list.sort((a, b) => querySort.compareFun(a[sortKey], b[sortKey], type) * flag)
                }
                $scope.dataList = list
            })
        }
    }
}

distributionCtrl.$inject = ['$scope', '$uibModal', 'httpRequest', 'logger', '$timeout', 'distributionService', 'querySort', 'initSortService']
export default distributionCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/distribution/distributionCtrl.js